import _ from 'lodash';
import * as types from '../../contactUs/constants/ActionTypes';
import { docTypeOptions, getSearchFilter } from '../../lib/customFields';

const FAQ = 'faq';

const initialState = {
  formUpdated: false,
  queryParams: {},
  fields: getSearchFilter(),
};

const preserveFormData = (state) => {
  const fields = getSearchFilter();
  const queryChannel = (state.queryParams && state.queryParams.channel) || '';
  let docType = FAQ;

  if (state.formUpdated && state.fields[0]) {
    docType = state.fields[0].value;
  } else if (queryChannel && _.has(docTypeOptions, queryChannel)) {
    docType = queryChannel;
  }

  fields[0].value = docType;

  return fields;
};

export default function (state = initialState, action) {
  switch (action.type) {
    case types.RECEIVE_QUERY_PARAMS:
      return Object.assign({}, state, { formUpdated: false, queryParams: action.payload });
    case types.PRESERVE_FILTER_FIELD_DATA:
      return Object.assign({}, state, { formUpdated: true, fields: action.payload });
    case types.RECEIVE_ARTICLE_SEARCH_RESPONSE:
      return Object.assign({}, state, { formUpdated: false, fields: preserveFormData(state) });
    case types.RECEIVE_ARTICLE_SEARCH_ERROR:
      return Object.assign({}, state, { formUpdated: false });
    case types.CLOSE_MOBILE_FILTER:
    case types.REQUEST_ARTICLE_SEARCH:
      _.remove(state.fields, field => (field.type === 'button'));
      return Object.assign({}, state);
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./home/reducers/reducer-search-filter-form.js